<template>
    <v-dialog v-model="dialog" scrollable persistent fullscreen>
        <template v-slot:activator="{ on }">
            <div class="d-inline text-left">
                <v-btn v-if="!esEdit" icon color="primary" v-on="on">
                    <v-icon>mdi-plus-circle</v-icon>
                </v-btn>

                <v-btn v-if="esEdit" icon color="primary" v-on="on">
                    <v-icon>mdi-square-edit-outline</v-icon>
                </v-btn>
            </div>
        </template>
        <v-card class="primary--text">
            <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
                {{ $t(titulo) }}
                <v-spacer></v-spacer>
                <v-btn icon right @click="cerrar" color="white">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row v-if="!esEdit">
                        <v-col cols="12">
                            {{ $t('descripcion') }}
                        </v-col>
                    </v-row>
                    <v-row v-if="esEdit && form.material">
                        <v-col cols="12">
                          <span v-html="$t('descripcion_mat', [form.material.nombre,
                               descripcionTipSolCons(form.material.tipoSolCons)])" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="form.codigo" :label="$t('label_cod')"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field v-model="form.referencia" :label="$t('label_ref')"></v-text-field>
                        </v-col>
                    </v-row>

                    <div v-if="!esEdit">
                        <v-row>
                            <v-col cols="12">
                                <v-select :label="$t('tipo_obra') | capitalize" v-model="form.tipoObra"
                                          :items="tiposDeObra" item-value="codigo"
                                          item-text="nombre"
                                          @change="seleccionarTipoObra"
                                          return-object>
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    :loading="solConsLoad"
                                    :disabled="solCons.length == 0"
                                    :label="$t('sol_cons') | capitalize" v-model="form.solCons"
                                    :items="solCons" item-value="codigo"
                                    item-text="nombre"
                                    @change="seleccionarSolCons"
                                    return-object>
                                </v-select>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12">
                                <v-select
                                    :loading="materialesLoad"
                                    :disabled="materiales.length == 0"
                                    :label="$t('material') | capitalize" v-model="form.material"
                                    :items="materiales" item-value="codigo"
                                    item-text="nombre"
                                    @change="seleccionarMaterial"
                                    return-object>
                                </v-select>
                            </v-col>
                        </v-row>
                    </div>

                    <v-row>
                        <v-col>
                            <v-text-field v-model="form.precio" type="number"
                                          :label="$t('label_precio')"></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col>
                            <v-card class="mx-auto" :elevation="addDap ? 1:0">
                                <v-card-title class="pa-0">
                                    <v-switch v-model="addDap" color="primary" class="mx-2"
                                              :label="$t('dap')"></v-switch>
                                </v-card-title>
                                <v-card-text v-show="addDap">
                                    <p>{{ $t('dap_descrip_eval') }}</p>
                                    <impactos-componente
                                        :mostrar-titulo="false"
                                        :nombre="$t('dap')"
                                        :impactos="impactos"
                                        :impactos-sol-cons="form.ambientales"></impactos-componente>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>

                    <v-row class="primary--text">
                        <v-col cols="12">
                            <v-card class="mx-auto" :elevation="addPres ? 1:0">
                                <v-card-title class="pa-0">
                                    <v-switch v-model="addPres" color="primary" class="mx-2"
                                              :disabled="form.material == null"
                                              :label="$t('dpres') | capitalize"></v-switch>
                                </v-card-title>
                                <v-card-text v-show="addPres">
                                    <v-col cols="12" v-for="(prestacional,i) in prestacionales" :key="i">
                                        <indicador-prestacional :indicador="prestacional"
                                                                :prestacion="form.prestacionales">
                                        </indicador-prestacional>
                                    </v-col>
                                </v-card-text>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer/>
                <v-btn color="error" :disabled="creando" text @click="dialog = false">
                    {{ $t('cerrar') | capitalize }}
                </v-btn>
                <v-btn color="primary" :loading="creando" depressed :disabled="!esValido()" @click="guardar()">
                    {{ $t('guardar') | capitalize }}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {HttpHelper} from "@/comunes/helpers/HttpHelper";
    import ImpactosComponente
        from "../../../proyecto-detalles/Componentes/SolucionConstructiva/DeclaracionAmbiental/Componentes/ImpactosComponente";
    import IndicadorPrestacional from "./Componentes/IndicadorPrestacional";
    import DescripcionesServicio from "../../../../comunes/servicios/DescripcionesServicio";

    export default {
        name: "BtnAddMaterialPers",
        props: {
            disabled: {type: Boolean, default: false},
            materialEdit: {type: Object, default: null}
        },
        components: {
            ImpactosComponente,
            IndicadorPrestacional
        },
        data: () => ({
            dialog: false,
            form: {
                tipoObra: null,
                solCons: null,
                material: null,
                codigo: null,
                referencia: null,
                precio: null,
                ambientales: {},
                prestacionales: {}
            },
            tiposDeObra: [],
            solConsLoad: false,
            solCons: [],
            materialesLoad: false,
            materiales: [],
            impactos: [],
            prestacionales: [],
            creando: false,
            addDap: false,
            addPres: false
        }),
        watch: {
            dialog: function (val) {
                if (val) this.init();
            }
        },
        computed: {
            esEdit() {
                if (this.materialEdit == null) return false;
                return true;
            },
            titulo() {
                if (this.materialEdit == null) return "dialog_titulo";
                return "dialog_titulo_edit";
            }
        },
        methods: {
            init() {
                this.form.tipoObra = null;
                this.form.solCons = null;
                this.form.material = null;
                this.form.codigo = null;
                this.form.referencia = null;
                this.form.precio = null;
                this.form.ambientales = {};
                this.form.prestacionales = {};

                this.obtenerTiposDeObra();
                this.cargarImpactos();
                if (this.materialEdit != null) {
                    this.form.material = this.materialEdit.material;
                    this.form.codigo = this.materialEdit.codigo;
                    this.form.referencia = this.materialEdit.referencia;
                    if (this.materialEdit.declaracionAmbientalDermis != null) {
                        this.form.ambientales = this.materialEdit.declaracionAmbientalDermis;
                        this.addDap = true;
                    }

                    if (this.materialEdit.prestacionDermis != null) {
                        this.form.prestacionales = this.materialEdit.prestacionDermis.parametros;
                        this.addPres = true;
                    }

                    this.form.precio = this.materialEdit.costeUnitarioAcabado;
                    this.cargarPrestacionales();
                }
            },
            obtenerTiposDeObra() {
                this.tiposDeObra = [];
                HttpHelper.get("tipos-obra")
                    .then((tipos) => {
                        this.tiposDeObra = tipos;
                    })
            },
            obtenerTiposDeSolcons() {
                this.solConsLoad = true;
                this.solCons = [];
                HttpHelper.get(`tipos-sol-cons/${this.form.tipoObra.codigo}`)
                    .then((tipos) => {
                        this.solCons = tipos;
                    })
                    .finally(() => {
                        this.solConsLoad = false;
                    })
            },
            obtenerMateriales() {
                this.materialesLoad = true;
                this.materiales = [];
                HttpHelper.get(`materiales/${this.form.solCons.codigo}/todos`)
                    .then((materiales) => {
                        this.materiales = materiales;
                    })
                    .finally(() => {
                        this.materialesLoad = false;
                    })
            },
            seleccionarTipoObra() {
                this.form.solCons = null;
                this.form.material = null;
                this.form.prestacionales = {};

                this.obtenerTiposDeSolcons();
            },
            seleccionarSolCons() {
                this.form.material = null;
                this.form.prestacionales = {};

                this.obtenerMateriales();
            },
            seleccionarMaterial() {
                this.form.prestacionales = {};

                this.cargarPrestacionales();
            },
            cargarImpactos() {
                this.impactos = [];

                HttpHelper.get("impactos").then(data => {
                    this.impactos = data;
                });
            },
            cargarPrestacionales() {
                this.prestacionales = [];
                if (this.form.material == null) return;

                HttpHelper.get(`material-personalizado/indicadores-prestacionales/${this.form.material.codigo}`)
                    .then(data => {
                        this.prestacionales = data;
                    });
            },
            descripcionTipSolCons(tipSolCons) {
                return DescripcionesServicio.descripcionTipoSolCons(tipSolCons);
            },
            guardar() {
                this.creando = true;

                if (this.esEdit) {
                    let dataEdit = {
                        codigo: this.form.codigo,
                        referencia: this.form.referencia,
                        precio: this.form.precio,
                        prestacion: this.form.prestacionales,
                        declaracionAmbiental: this.form.ambientales
                    };
                    this.edit(this.materialEdit.id, dataEdit);
                } else {
                    let dataAdd = {
                        materialId: this.form.material.id,
                        codigo: this.form.codigo,
                        referencia: this.form.referencia,
                        precio: this.form.precio,
                        prestacion: this.form.prestacionales,
                        declaracionAmbiental: this.form.ambientales
                    };
                    this.add(dataAdd);
                }
            },
            add(data) {
                HttpHelper.post("material-personalizado/anyadir", data)
                    .then(() => {
                        this.reset();
                        this.dialog = false;
                        this.$emit("actualizado");
                    })
                    .catch(() => {

                    })
                    .finally(() => {
                        this.creando = false;
                    });
            },
            edit(id, data) {
                HttpHelper.post(`material-personalizado/${id}/editar`, data)
                    .then(() => {
                        this.reset();
                        this.dialog = false;
                        this.$emit("actualizado");
                    })
                    .catch(() => {

                    })
                    .finally(() => {
                        this.creando = false;
                    });
            },
            reset() {
                this.form.tipoObra = null;
                this.form.solCons = null;
                this.form.material = null;
                this.form.codigo = null;
                this.form.referencia = null;
                this.form.precio = null;
                this.form.ambientales = {};
                this.form.prestacionales = {};
            },
            cerrar() {
                this.dialog = false;
            },
            esValido() {
                if (this.form.codigo == null || this.form.codigo.length == 0) return false;
                if (this.form.referencia == null || this.form.referencia.length == 0) return false;
                if (this.form.material == null) return false;
                if (this.form.precio == null || this.form.precio.length == 0) return false;

                return true;
            }
        },
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "ceramico": "Cerámico",
    "no_ceramico": "No cerámico",
    "btn_guardar": "guardar material",
    "dialog_titulo": "crear material personalizado",
    "tipo_obra": "tipo de obra del material",
    "selec_tipo_obra_primero": "Se debe de seleccionar antes el tipo de obra",
    "sol_cons": "tipo de solución constructiva del material",
    "selec_sol_cons_primero": "Se debe de seleccionar antes el tipo de solución constructiva",
    "selec_material": "Se debe de seleccionar antes el material",
    "material":"Material",
    "descripcion": "Al guardar un material personalizado se guardan el precio, declaración ambiental y declaración prestacional para que al crear un nuevo proyecto puedas seleccionar este material con su personalización",
    "label_cod":"Código",
    "label_ref":"Referencia",
    "label_precio":"Precio",
    "dap":"Declaración ambiental",
    "dpres":"características técnicas",
    "dialog_titulo_edit": "actualizar material personalizado",
    "descripcion_mat" : "<span class='font-weight-bold'>Material:</span> {0} ({1})"
    }
    }
</i18n>
<!--@formatter:on-->